import { httpRequest } from "@services/http";
import type { LaunchDetail } from "../models/launchDetail";
import { legacyDashboardUrl } from "./legacyDashboardUrl";

export class CommandGetLaunchDetail {
    async run(launchId: string): Promise<LaunchDetail> {
        return await httpRequest<LaunchDetail>(legacyDashboardUrl(`launch-list/${launchId}/`).toString());
    }
}
